import React, {Fragment} from "react"
import Marquee from "react-fast-marquee";

const MarqueSlider = () => {
    return (
        <Fragment>
            <div className="pt-75 pb-130 pb-lg-60">
                <Marquee pauseOnHover={true} className="marquee-line">
                    <h3 className="marque-text">Tecnología para elevar nuestra experiencia humana. Tu Próxima Agencia de Soluciones IT &
                    Explorar Más Tecnología para elevar nuestra experiencia humana. Tu Próxima Agencia de Soluciones IT
                    & Explorar Más</h3>
                </Marquee>
            </div>
        </Fragment>
    )
}

export default MarqueSlider